<app-loading-indicator></app-loading-indicator>

<section class="section section-square-pattern"></section>
